import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon';
import 'virtual:svg-icons-register';

Vue.component('svg-icon', SvgIcon);